import React, { useState, useEffect } from "react";
import { Details, SearchResults } from "../components/FastGauge";
import { Text, FlexRow, Wrapper } from "../components/";
import FilterForm from "../components/FastGauge/FilterForm/FilterForm";

const FastGuage = () =>  
{
    const [battleChips, setBattleChips] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    
    //Only fetch these once.
    const [elements, setElements] = useState([]);
    const [panelEffects, setPanelEffects] = useState([]);

    const [endpoint, setEndpoint] = useState("bn6");
    const [active, setActive] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect( () => {
        const fetchData = async () => {
    
            const elements = await fetch("https://fastgauge.azurewebsites.net/api/elements");
            const panelEffects = await fetch("https://fastgauge.azurewebsites.net/api/panelEffects");

            setElements( await elements.json() );
            setPanelEffects( await panelEffects.json() );
        };

        fetchData();
    }, []);

    useEffect( () => 
    {
        {
            const fetchBattleChips = async () =>
            {
                const url = `https://fastgauge.azurewebsites.net/api/${endpoint}`;
    
                const response = await fetch(url);
                const responseJSON = await response.json();
                setBattleChips(responseJSON);
            };
    
            fetchBattleChips();
            setLoading(false);
        }

    }, [endpoint]);

    const handleClick = (selectedChip) => {

        const newActive = battleChips.find(chip => chip.gameId === selectedChip);

        setActive(newActive);
    }

    return (
        <Wrapper>

            <FilterForm chipData={battleChips}/>
        
            <FlexRow>
            {
                (isLoading) ? <Text>Fetching...</Text> : 
                <SearchResults resultsList={searchResults} handleClick={handleClick}></SearchResults>
            }

            {active ? <Details battleChip={active} elements={elements} panelEffects={panelEffects}/> : <div>Thing here</div>} 
        
            </FlexRow>
        </Wrapper>

    );
}

export default FastGuage;
